import React from 'react';
import Icon from 'shared/components/icon';
import styles from './styles.module.scss';

export default function CheckedValue(value): React.ReactElement {
  return (
    <Icon
      iconType={value ? 'check-r' : 'times-r'}
      className={value ? styles.allowed : styles.denied}
    />
  );
}
